import { Search, Bell, User } from "lucide-react";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export function AppHeader() {
  return (
    <header className="h-14 border-b border-border/60 glass-subtle flex items-center justify-between px-4 sticky top-0 z-50">
      <div className="flex items-center gap-4 flex-1">
        <SidebarTrigger className="text-muted-foreground hover:text-primary transition-colors" />
        <div className="relative max-w-sm w-full">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-muted-foreground/60" />
          <Input
            placeholder="Buscar projetos, orçamentos..."
            className="pl-9 h-9 text-body-sm bg-muted/30 border-border/50 focus:border-primary/50 focus:bg-muted/50 transition-all"
          />
        </div>
      </div>

      <div className="flex items-center gap-2">
        <Button variant="ghost" size="icon" className="relative h-9 w-9 text-muted-foreground hover:text-primary transition-colors">
          <Bell className="h-4 w-4" />
          <span className="absolute top-1.5 right-1.5 w-1.5 h-1.5 bg-accent rounded-full animate-pulse-glow" />
        </Button>

        <div className="w-px h-6 bg-border/50 mx-1" />

        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" className="gap-2 px-2 h-9 hover:bg-muted/50 transition-colors">
              <Avatar className="h-7 w-7">
                <AvatarImage src="" alt="Usuário" />
                <AvatarFallback className="bg-gradient-primary text-xs font-display font-semibold text-primary-foreground">
                  EU
                </AvatarFallback>
              </Avatar>
              <div className="text-left hidden md:block">
                <p className="text-body-sm font-medium leading-none font-display">Engenheiro Silva</p>
                <p className="text-body-xs text-accent font-mono mt-0.5">Pro</p>
              </div>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-52 dropdown-sinapise">
            <DropdownMenuLabel className="font-display">Minha Conta</DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem className="font-sans">
              <User className="mr-2 h-4 w-4" />
              Perfil
            </DropdownMenuItem>
            <DropdownMenuItem className="font-sans">Configurações</DropdownMenuItem>
            <DropdownMenuItem className="font-sans">Planos e Assinatura</DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem className="text-destructive font-sans font-medium">
              Sair
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
}
